import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import useBoolean from '@eduzz/houston-hooks/useBoolean';
import Content from './Content';
import LayoutContext from './context';
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import styled, { css, cx } from '../styled';
import nestedComponent from '../utils/nestedComponent';
const Layout = (_a) => {
    var { className, children } = _a, rest = __rest(_a, ["className", "children"]);
    const [hasTopbar, setHasTopbar] = React.useState(false);
    const [hasSidebar, setHasSidebar] = React.useState(false);
    const [hasUserMenu, setHasUserMenu] = React.useState(false);
    const [topbarCenterContainer, setTopbarCenterContainer] = React.useState(null);
    const [userMenuContainer, setUserMenuContainer] = React.useState(null);
    const [userMenuOpened, toogleUserMenuOpened, trueUserMenuOpened, falseUserMenuOpened] = useBoolean(false);
    const [sidebarOpened, toogleSidebarOpened, trueSidebarOpened, falseSidebarOpened] = useBoolean(false);
    const registerTopbar = React.useCallback(() => {
        setHasTopbar(true);
        return () => setHasTopbar(false);
    }, []);
    const registerSidebar = React.useCallback(() => {
        setHasSidebar(true);
        return () => setHasSidebar(false);
    }, []);
    const registerTopbarCenterContainer = React.useCallback((div) => {
        setTopbarCenterContainer(div);
    }, []);
    const registerUserMenu = React.useCallback(() => {
        setHasUserMenu(true);
        return () => setHasUserMenu(false);
    }, []);
    const registerUserMenuContainer = React.useCallback((div) => {
        setUserMenuContainer(div);
    }, []);
    const contextValue = React.useMemo(() => ({
        topbar: {
            exists: hasTopbar,
            centerPortal: topbarCenterContainer,
            register: registerTopbar,
            registerCenterPortal: registerTopbarCenterContainer
        },
        sidebar: {
            exists: hasSidebar,
            opened: sidebarOpened,
            register: registerSidebar,
            toogleOpened: toogleSidebarOpened,
            trueOpened: trueSidebarOpened,
            falseOpened: falseSidebarOpened
        },
        userMenu: {
            opened: userMenuOpened,
            containerPortal: userMenuContainer,
            exists: hasUserMenu,
            register: registerUserMenu,
            registerContainerPortal: registerUserMenuContainer,
            toogleOpened: toogleUserMenuOpened,
            trueOpened: trueUserMenuOpened,
            falseOpened: falseUserMenuOpened
        }
    }), [
        falseSidebarOpened,
        falseUserMenuOpened,
        hasSidebar,
        hasTopbar,
        hasUserMenu,
        registerSidebar,
        registerTopbar,
        registerTopbarCenterContainer,
        registerUserMenu,
        registerUserMenuContainer,
        sidebarOpened,
        toogleSidebarOpened,
        toogleUserMenuOpened,
        topbarCenterContainer,
        trueSidebarOpened,
        trueUserMenuOpened,
        userMenuContainer,
        userMenuOpened
    ]);
    return (_jsx(LayoutContext.Provider, Object.assign({ value: contextValue }, { children: _jsx("div", Object.assign({ className: cx(className, { 'hst-layout-has-topbar': hasTopbar }) }, rest, { children: children })) })));
};
const LayoutWrapper = styled(Layout, { label: 'hst-layout' }) `
  ${({ theme }) => css `
    display: flex;
    width: 100%;
    min-height: 100vh;

    &.hst-layout-has-topbar {
      padding-top: ${theme.pxToRem(theme.components.topBarHeight)}rem;
    }
  `}
`;
export default nestedComponent(LayoutWrapper, {
    Sidebar,
    Content,
    Topbar
});
